import { Mail } from "lucide-react";
import { Card } from "../../ui";
import { formatCpfCnpj } from "../../../lib/masks";
import { Label, Input } from "./shared";

export function ReceiptCreateForm({ associados, busy, form, items, onAssociateChange, openCreate, setForm, setOpenCreate, submitCreate }) {
  return (
    <>
      {openCreate && (
        <Card className="p-5 mb-6">
          <form
            data-testid="receipt-form"
            onSubmit={submitCreate}
            className="grid md:grid-cols-2 gap-4"
          >
            <div className="md:col-span-2">
              <Label>Associado (opcional — preenche os dados automaticamente)</Label>
              <select
                data-testid="receipt-associate"
                value={form.associate_id}
                onChange={(e) => onAssociateChange(e.target.value)}
                className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm bg-white"
              >
                <option value="">— Recibo para terceiro (não associado) —</option>
                {associados.map((a) => (
                  <option key={a.id} value={a.id}>
                    {a.name} · {a.email}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <Label>Tipo de pessoa *</Label>
              <div className="mt-1 flex gap-2">
                {["PF", "PJ"].map((v) => (
                  <button
                    type="button"
                    key={v}
                    data-testid={`receipt-tipo-${v}`}
                    onClick={() =>
                      setForm((f) => ({ ...f, payer_person_type: v }))
                    }
                    className={`flex-1 px-3 py-2.5 border rounded-sm text-sm ${
                      form.payer_person_type === v
                        ? "bg-[#0A0F14] text-white border-[#0A0F14]"
                        : "bg-white text-slate-700 border-slate-300 hover:border-[#002776]"
                    }`}
                  >
                    {v === "PF" ? "Pessoa Física" : "Pessoa Jurídica"}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <Label>
                {form.payer_person_type === "PJ" ? "CNPJ *" : "CPF *"}
              </Label>
              <Input
                testid="receipt-document"
                required
                value={form.payer_document}
                onChange={(e) =>
                  setForm({
                    ...form,
                    payer_document: formatCpfCnpj(
                      e.target.value,
                      form.payer_person_type
                    ),
                  })
                }
                placeholder={
                  form.payer_person_type === "PJ"
                    ? "XX.XXX.XXX/XXXX-XX"
                    : "XXX.XXX.XXX-XX"
                }
                maxLength={form.payer_person_type === "PJ" ? 18 : 14}
              />
            </div>
            <div className="md:col-span-2">
              <Label>Nome / Razão Social *</Label>
              <Input
                testid="receipt-name"
                required
                minLength={2}
                value={form.payer_name}
                onChange={(e) =>
                  setForm({ ...form, payer_name: e.target.value })
                }
              />
            </div>
            <div className="md:col-span-2">
              <Label>Endereço completo *</Label>
              <Input
                testid="receipt-address"
                required
                minLength={4}
                value={form.payer_address}
                onChange={(e) =>
                  setForm({ ...form, payer_address: e.target.value })
                }
                placeholder="Rua, número, bairro, cidade — UF, CEP"
              />
            </div>
            <div>
              <Label>E-mail para envio</Label>
              <Input
                testid="receipt-email"
                type="email"
                value={form.payer_email}
                onChange={(e) =>
                  setForm({ ...form, payer_email: e.target.value })
                }
                placeholder="opcional · vai junto com os do associado"
              />
            </div>
            <div>
              <Label>Valor (R$) *</Label>
              <Input
                testid="receipt-amount"
                type="number"
                step="0.01"
                min="0.01"
                required
                value={form.amount}
                onChange={(e) => setForm({ ...form, amount: e.target.value })}
              />
            </div>
            <div>
              <Label>Referente ao boleto de número</Label>
              <Input
                testid="receipt-boleto-number"
                value={form.boleto_number}
                onChange={(e) =>
                  setForm({ ...form, boleto_number: e.target.value })
                }
                placeholder="opcional · ex.: 000123 ou linha digitável"
                maxLength={80}
              />
            </div>
            <div className="md:col-span-2">
              <Label>Motivo / Referente a *</Label>
              <textarea
                data-testid="receipt-reason"
                required
                minLength={3}
                value={form.reason}
                onChange={(e) =>
                  setForm({ ...form, reason: e.target.value })
                }
                placeholder="Ex.: Contribuição mensal de junho/2026 — categoria Contribuinte"
                className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm min-h-[100px]"
              />
            </div>
            <div className="md:col-span-2 flex gap-2 items-center">
              <button
                disabled={busy}
                data-testid="receipt-submit"
                className="px-5 py-2.5 bg-[#0A0F14] text-white text-[11px] uppercase tracking-[0.22em] hover:bg-[#002776] disabled:opacity-60"
              >
                {busy ? "Emitindo..." : "Emitir recibo e enviar"}
              </button>
              <button
                type="button"
                onClick={() => setOpenCreate(false)}
                className="px-5 py-2.5 border border-slate-300 text-[11px] uppercase tracking-[0.22em] hover:border-[#002776]"
              >
                Cancelar
              </button>
              <div className="ml-auto text-xs text-slate-500 inline-flex items-center gap-1">
                <Mail size={12} /> Será enviado para todos os e-mails
                cadastrados (principal + boleto + financeiro).
              </div>
            </div>
          </form>
        </Card>
      )}

    </>
  );
}
